<template>
  <el-tabs type="border-card">
    <el-tab-pane label="日报">
      <revenue-chart-one/>
    </el-tab-pane>
    <el-tab-pane label="月报">
      <revenue-chart-two/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import RevenueChartOne from "./RevenueChart/RevenueChartOne";
import RevenueChartTwo from "./RevenueChart/RevenueChartTwo";

export default {
  name: "RevenueChart",
  components: {RevenueChartTwo, RevenueChartOne},
}
</script>


